/// <reference path="../../../scripts/typings/klintra.crew.types.d.ts" />
/// <reference path="../../../scripts/typings/Nema.Crew.Model.d.ts" />

import { Injectable, Inject } from '@angular/core';
import { ServiceConfig } from "./core.constants";

@Injectable()
export class DashboardDataService implements IDashboardDataService {

    private $http: ng.IHttpService;

    private searchDayActivitiesServiceUrl = ServiceConfig.webApiUrl + "DashboardService/SearchDayActivitiesPost/";
    private searchDayOnBoardServiceUrl = ServiceConfig.webApiUrl + "DashboardService/SearchDayOnBoardPost/";
    private searchDayCompetencesStatusServiceUrl = ServiceConfig.webApiUrl + "DashboardService/SearchDayCompetencesStatusPost/";
    private searchDayWorkplaceCompetenceStatusUrl = ServiceConfig.webApiUrl + "DashboardService/WorkplaceCompetenceStatusPost/";

    constructor( @Inject("$http") $http: ng.IHttpService) {
        this.$http = $http;
    }

    public searchDayActivities(searchDayActivitiesQuery: SearchDayActivitiesQuery): ng.IPromise<Nema.Crew.Model.DashboardDayActivitySum[]> {
        return this.$http
            .post(this.searchDayActivitiesServiceUrl, JSON.stringify(searchDayActivitiesQuery))
            .then(res => <Nema.Crew.Model.DashboardDayActivitySum[]>res.data);
    }

    public searchDayOnBoard(searchDayActivitiesQuery: SearchDayOnBoardQuery): ng.IPromise<Klintra.Crew.Types.DashboardDayOnBoard> {
        return this.$http
            .post(this.searchDayOnBoardServiceUrl, JSON.stringify(searchDayActivitiesQuery))
            .then(res => <Klintra.Crew.Types.DashboardDayOnBoard>res.data);
    }

    public searchDayCompetencesStatus(searchDayCompetencesStatusQuery: SearchDayCompetencesStatusQuery): ng.IPromise<Klintra.Crew.Types.DashboardDayCompetencesStatus[]> {
        return this.$http
            .post(this.searchDayCompetencesStatusServiceUrl, JSON.stringify(searchDayCompetencesStatusQuery))
            .then(res => <Klintra.Crew.Types.DashboardDayCompetencesStatus[]>res.data);
    }

    public searchDayWorkplaceCompetenceStatus(searchDayCompetencesStatusQuery: SearchDayCompetencesStatusQuery): ng.IPromise<Klintra.Crew.Types.DashboardDayWorkplaceCompetenceStatus[]> {
        return this.$http
            .post(this.searchDayWorkplaceCompetenceStatusUrl, JSON.stringify(searchDayCompetencesStatusQuery))
            .then(res => <Klintra.Crew.Types.DashboardDayWorkplaceCompetenceStatus[]>res.data);
    }
}

export interface IDashboardDataService {
    searchDayActivities(searchActivitiesDayQuery: SearchDayActivitiesQuery): ng.IPromise<Nema.Crew.Model.DashboardDayActivitySum[]>;
    searchDayOnBoard(searchDayActivitiesQuery: SearchDayOnBoardQuery): ng.IPromise<Klintra.Crew.Types.DashboardDayOnBoard>;
    searchDayCompetencesStatus(searchDayCompetencesStatusQuery: SearchDayCompetencesStatusQuery): ng.IPromise<Klintra.Crew.Types.DashboardDayCompetencesStatus[]>;
    searchDayWorkplaceCompetenceStatus(searchDayCompetencesStatusQuery: SearchDayCompetencesStatusQuery): ng.IPromise<Klintra.Crew.Types.DashboardDayWorkplaceCompetenceStatus[]>;
}

export interface SearchDayActivitiesQuery {
    Day: Date;
    PersonIds: number[];
    WorkplaceIds: number[];
    ActivityTypeIds: number[];
    JobTitleIds: number[];
}

export interface SearchDayOnBoardQuery {
    Day: Date;
}

export interface SearchDayCompetencesStatusQuery {
    Day: Date;
    Name: string;
    Value: number;
    Color: string;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/dashboarddataservice.ts